import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
var messages = defineMessages({
  mindBodyImg: {
    id: 'reservation.powered-by-mindbody',
    defaultMessage: 'Powered by MindBody'
  }
});
export var MindBody = function MindBody(_ref) {
  var intl = _ref.intl;
  return React.createElement("a", {
    className: "modal__powered-by",
    href: "https://www.mindbodyonline.com/",
    target: "_blank",
    rel: "noopener noreferrer"
  }, React.createElement("img", {
    src: "/img/mindbody-powered-logo.png",
    alt: intl.formatMessage(messages.mindBodyImg),
    width: "140",
    height: "43"
  }));
};
MindBody.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired
};
export var MindBodyLink = injectIntl(MindBody);